import './SavingsDepositTransactions.css'
import {
    Box,
    Button,
    FormControl,
    Grid,
    InputAdornment,
    InputLabel,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import * as React from "react";
import closeIcon from '../../assets/images/closeVector.svg'
import groupIcon from "../../assets/images/group.svg";
import searchIcon from "../../assets/images/search-normal.svg";

const SavingsDepositTransactions = () => {
    return (
       <div></div>

    )
}
export default SavingsDepositTransactions;